// CORE-847 §7 — the pop-up header's controls.
//
// The close affordance moved here from the launcher, and the spec is specific
// about its weight: «компактная, круглая/ghost, визуально лёгкая, без яркой
// заливки по умолчанию», with a warm accent only under hover or focus. Same
// button serves the «open full chat» arrow beside it, so the two never drift
// apart visually.
import React, { useState } from 'react';
import { Platform, Pressable, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { useTheme } from '../context/ThemeContext';

import { ACCENT_TEXT } from '../styles/accentText';
const IS_WEB = Platform.OS === 'web';

interface Props {
  name: React.ComponentProps<typeof Ionicons>['name'];
  accessibilityLabel: string;
  onPress: () => void;
  size?: number;
  testID?: string;
}

export const WidgetIconButton: React.FC<Props> = ({ name, accessibilityLabel, onPress, size = 17, testID }) => {
  const { colors } = useTheme();
  const [active, setActive] = useState(false);

  return (
    <Pressable
      testID={testID}
      onPress={onPress}
      onHoverIn={IS_WEB ? () => setActive(true) : undefined}
      onHoverOut={IS_WEB ? () => setActive(false) : undefined}
      onFocus={() => setActive(true)}
      onBlur={() => setActive(false)}
      hitSlop={6}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      style={[
        styles.button,
        {
          borderColor: active ? 'rgba(233, 130, 69, 0.55)' : colors.border,
          backgroundColor: active ? 'rgba(233, 130, 69, 0.14)' : 'transparent',
        },
        IS_WEB && ({ cursor: 'pointer', transition: 'background-color 160ms ease, border-color 160ms ease' } as any),
      ]}
    >
      <Ionicons name={name} size={size} color={active ? ACCENT_TEXT : colors.textMuted} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  button: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: StyleSheet.hairlineWidth,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
